module.exports = __webpack_public_path__ + "img/korea_24.372d4bfe.png";